import * as React from "react";
import {css} from "@emotion/react";

import {LoginForm} from "../components/LoginForm";

const fullWidthViewBg = require("../../app/img/login.jpg");

export const LoginView = () => {
    return (
        <div css={fullWidthViewHolder}>
            <LoginForm />
        </div>
    );
};

export const fullWidthViewHolder = () => css`
    background-image: linear-gradient(to right, rgba(144, 105, 192, 0.3) 0%, rgba(144, 105, 192, 0.3) 100%), url(${fullWidthViewBg});
    background-blend-mode: color;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
`;
